import PropTypes from 'prop-types'

import { useProfile } from 'catalog/hooks/use-profile'

const ContextVisibility = ({ when = [], children = null }) => {
  const { profile } = useProfile()

  if (when.includes(profile.context)) {
    return children
  }

  return null
}

ContextVisibility.propTypes = {
  when: PropTypes.arrayOf(PropTypes.oneOf(['app', 'assisted-sale', 'ecommerce'])),
  children: PropTypes.node
}

export default ContextVisibility
